import styled from 'styled-components';

import { style } from '@genially/design-system';
import { ArrowEndPointIconIcon } from '@genially/icons';

import { ResponsiveText } from '../../../../../../../../shared/application/components/ResponsiveText/ResponsiveText';

export const Card = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: size.units(4),

  width: '100%',

  padding: `${size.units(8)} ${size.units(4)}`,
}));

export const StyledResponsiveText = styled(ResponsiveText)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const StyledArrowEndPointIcon = styled(ArrowEndPointIconIcon)(
  ({ theme: { color, size } }) => ({
    width: size.units(2),
    height: size.units(2),
    color: color.content.reversed.default(),
  }),
);

export const UsernameSelectionWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  gap: size.units(1.5),
  alignItems: 'center',
  width: '100%',

  ...style.mixins.responsive.xs.downward({
    flexDirection: 'column',
    gap: size.units(2),
  }),
}));

export const ErrorWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ContentWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(2),
  width: '100%',
}));
